import { useSetCandidateId } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateGet } from "#candidate/services/api"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { TableMain } from "#core/components/table-main/TableMain"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { Box, Chip, Stack } from "@mui/material"
import { useMemo } from "react"
import { useNavigate } from "react-router-dom"

export default function CandidateTable({ vacancyId, autoFetch }) {
	const navigate = useNavigate()
	const { reload } = useCandidateRedux()
	const { setCandidateId } = useSetCandidateId()
	const params = useMemo(() => ({ vacante_Id: vacancyId, table: true }), [vacancyId])
	const { data, loading, error } = useApi(candidateGet, { params, autoFetch, reload })
	const candidates = useMemo(() => data?.data || [], [data])

	const items = [
		{ label: "Nombre", name: "full_name" },
		{ label: "Correo", name: "correo" },
		{ label: "Teléfono", name: "celular" },
		{
			label: "Status",
			name: "status_name",
		},
		{
			label: " ",
			name: "is_enabled",
			options: {
				customBodyRender: (value, data) => (
					<Stack direction="row" spacing={1}>
						<Chip
							label={value ? "Habilitado" : "Deshabilitado"}
							color={value ? "success" : "error"}
							size={"medium"}
						/>
					</Stack>
				),
			},
		},
	]
	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box>
			<TableMain
				items={items}
				data={candidates}
				options={{
					selectedRow: true,
					onClickRow: (candidato) => {
						navigate(`../candidate/${candidato.id}`)
						setCandidateId(candidato?.id)
					},
				}}
			/>
		</Box>
	)
}
